module.exports = __webpack_public_path__ + "5626dc9cd4ee84e8a5477f6b704044bc.svg";